module.exports = __webpack_public_path__ + "static/media/A4.7dd13eab.pdf";